import { CloseButton, Flex, Heading, SxProps } from '@modusign/design-system';
import { ReactNode } from 'react';

interface WindowModalHeaderProps extends SxProps {
  children: ReactNode;
  onClose?: () => void;
}

function WindowModalHeader({ children, sx, onClose }: WindowModalHeaderProps) {
  return (
    <Flex
      alignItems="center"
      backgroundColor="lightGray50"
      borderBottom="1px solid"
      borderBottomColor="lightGray300"
      borderTopLeftRadius="3px"
      borderTopRightRadius="3px"
      height="65px"
      p={6}
      width="100%"
    >
      <Heading as="h1" flex="auto" fontSize="md" fontWeight="medium" sx={sx}>
        {children}
      </Heading>
      {onClose && (
        <CloseButton
          aria-label="닫기 버튼"
          m={0}
          sx={{ flex: 'none', transform: 'translateX(5px)' }}
          onClick={onClose}
        />
      )}
    </Flex>
  );
}

export default WindowModalHeader;
